import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HandlerErrorService } from './handler-error.service';
import { environment } from 'src/environments/environment';
import { catchError, map, Observable } from 'rxjs';
import { Dollar } from '../../home/Interfaces/DollarInterfaces';

@Injectable({
  providedIn: 'root',
})
export class ConversionService {
  url = environment.API_URL;

  dataClient: any;
  constructor(private http: HttpClient, private error: HandlerErrorService) {}

  public getPrecioDolar(): Observable<any> {
    let date: Date = new Date();
    const fech = this.formatDate(date);

    return this.http
      .get<Dollar[]>(`${this.url}/api/gsoft/services/dollar/?fecha=` + fech)
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err) => this.error.handlerError(err))
      );
  }

  public getPrecioDolarDate(fech: any): Observable<any> {
    // let date: Date = new Date();
    // const fech=this.formatDate(date);

    return this.http
      .get(`${this.url}/api/gsoft/services/dollar/?fecha=` + fech)
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err) => this.error.handlerError(err))
      );
  }

  public validatePago(data: any): Observable<any> {
    return this.http
      .post<void>(
        `${environment.API_URL}/api/gsoft/payments/pmbd/validate/`,
        data
      )
      .pipe(
        map((resp) => {
          // console.log(resp)
          return resp;
        }),
        catchError((err) => this.error.handlerError(err))
      );
  }
  // Esta funcion es para escribir solo numero en un input type text
  onInputChange(data: any) {
    const newValue = data.target.value.replace(/[^0-9\\.]/g, '');
    return newValue;
  }

  formatDate(date: any) {
    if (date != null) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    } else {
      return '';
    }
  }
  public getPrecioDolarNota(fecha: any): Observable<any> {
    const [year, month] = fecha.split('-');
    const firstDayOfMonth = `${year}-${month}-01`;

    // Crea una nueva fecha usando el primer día del mes en formato UTC
    let date: Date = new Date(firstDayOfMonth);
    console.log(fecha);

    // Obtén la fecha formateada (debería imprimir "2023-11-01")
    let fech = this.formatDate(fecha);
    return this.http
      .get(
        `${this.url}/api/gsoft/services/dollar/?currency=1&fecha=${fech}&status=true`
      )
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((err) => this.error.handlerError(err))
      );
  }
}
